import { defineDeckPassive } from '../authoring/index.js';
export const SteadyRecoveryPassive = defineDeckPassive({
    id: 'steady_recovery',
    role: 'available',
    presentation: {
        name: 'Регенерация',
        description: 'В конце каждого раунда восстанавливает вам 1 здоровье.',
        glyph: {
            colors: ['#10213A', '#830E2E', '#A51537', '#B4183A', '#600523'],
            rows: [
                '.........11.1.......',
                '........123131.1....',
                '........134431121...',
                '.....111344342331...',
                '....1222425554311...',
                '...115..2524425521..',
                '..12342225245522551.',
                '..1444455442522511..',
                '.1244453353254421...',
                '.1222244453454421...',
                '.1555244534445221...',
                '..122444354422251...',
                '..122243453344421...',
                '..152244432244321...',
                '...1522455442421....',
                '....122442444421....',
                '.....5223244221.....',
                '.....152222221......',
                '......1522221.......',
                '.......11111........',
            ],
        },
    },
    hooks: {
        onRoundEnd(ctx) {
            if (ctx.effect?.scope.kind !== 'player')
                return;
            ctx.ops.restorePlayerHealth(ctx.effect.scope.playerId, 1);
        },
    },
});
//# sourceMappingURL=steady_recovery.js.map